import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-gsyh",
  "use": "icon-gsyh-usage",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-gsyh\"></symbol>"
});
var result = sprite.add(symbol);
export default symbol